import { render, staticRenderFns } from "./WhyCbd.vue?vue&type=template&id=df3786b4&"
import script from "./WhyCbd.vue?vue&type=script&lang=js&"
export * from "./WhyCbd.vue?vue&type=script&lang=js&"
import style0 from "./WhyCbd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports